import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["errorMessage"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { DefaultText } from './Paragraph';
const ValidationSummary = _ref => {
  let {
      errorMessage
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  if (!errorMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DefaultText, _extends({
    margin: 4,
    textAlign: "justify",
    color: theme.palette.error.main
  }, rest), errorMessage);
};
export { ValidationSummary };